import Bowser from "bowser";

const os = Bowser.getParser(window?.navigator?.userAgent)?.getOS();

export const getOS = () => {
    return os;
}